import {
  SET_ITEMS,
  SET_TOTAL,
  SET_CRITERE_RECHERCHE,
} from '@/store/modules/baux/factureAchat-mutation-type';
import * as allTypes from '@/store/mutation-type';
import { getAll } from '@/api/factureAchat/';
import genererCritereRechercheFactureAchat
  from '@/services/baux/factureAchat/genererCritereRechercheFactureAchat';
import trierIntervenants from '@/services/devisCommandes/trierIntervenants';

function initialState() {
  return {
    items: [],
    total: 0,
    criteresRecherche: genererCritereRechercheFactureAchat(),
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadFactureAchat({ commit }, data) {
    const result = await getAll(data);
    result.data.result.items.forEach((facture) => {
      let listeIntervenants = '';
      trierIntervenants(facture);
      listeIntervenants = facture.intervenants.map((el) => el.nomCommercial).join(', ');
      facture.listeIntervenants = listeIntervenants;
    });
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
